<template>
  <div>
    <v-btn color="red" outlined small @click="abrirDialog">
      <v-progress-linear
        v-if="qtde_categorias_silenciados === null"
        indeterminate
        color="white"
        style="width: 162px"
      />

      <template v-else>
        {{ qtde_categorias_silenciados }} ite{{qtde_categorias_silenciados === 1 ? 'm' : 'ns'}} silenciados
        <v-icon size="15" class="ml-1">mdi-bell-off</v-icon>
      </template>
    </v-btn>

    <SysDialogFullscreen v-model="dialog_ativo" titulo="Categorias com Notificação Silenciada">
      <div class="d-flex align-center pt-3 pb-2 px-2">
        <v-icon :size="21" color="black">mdi-format-list-bulleted</v-icon>
        <span class="font-18 font-weight-medium text-gray-1000 ml-1">Lista de Categorias</span>

        <v-btn
          v-if="categorias_selecionadas.length > 0"
          class="ml-10"
          color="error"
          small
          @click="excluirCategoriasSilenciadas(arrayColumn(categorias_selecionadas, 'id'))"
        >
          <v-icon :size="20" class="mr-1">mdi-delete</v-icon>
          excluir
          <span class="qtde-top-button-small">{{categorias_selecionadas.length}}</span>
        </v-btn>

        <v-spacer />

        <div class="w-450">
          <v-text-field
            v-model="pesquisa"
            hide-details
            dense clearable
            label="Pesquisar"
            append-icon="mdi-magnify"
            v-lazy-input:debounce="1000"
          />
        </div>
      </div>

      <sys-data-table
        v-model="categorias_selecionadas"
        :height="altura_janela - 150"
        :item-height="45"
        :headers="headers"
        :items="categorias_silenciadas"
        :search="pesquisa"
        class="ml-1"
        show-select
      >
        <template #item.acoes="{ item }">
          <div class="d-flex align-center">
            <v-btn icon @click="excluirCategoriasSilenciadas([item.id])">
              <v-icon>mdi-delete</v-icon>
            </v-btn>

            <SilenciarCategoria
              :idgrupo="Number(GRUPO_COMPRA_COMPUTED)"
              :categorias="[item.id_categoria]"
              @categorias-silenciadas="categorias_selecionadas = [];buscarCategoriasSilenciadas()"
            >
              <template #default="{ callback }">
                <v-btn icon @click.stop="callback">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
            </SilenciarCategoria>
          </div>
        </template>
      </sys-data-table>
    </SysDialogFullscreen>
  </div>
</template>

<script setup>
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import * as req from "@/api/compras/MateriaPrima/NotificacaoBlackList";
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {arrayColumn, logout} from "@/helpers";
import {useResize} from "@/helpers/Resize";
import SilenciarCategoria from "@/components/compra/materiaPrima/compra/Silenciar/SilenciarCategoria.vue";

const {altura_janela} = useResize();

const headers = [
  { text: "Grupo", value: "descricao_grupo" },
  // { text: "Filial", value: "filial" },
  { text: "ID Categoria", value: "id_categoria" },
  { text: "Descrição da Categoria", value: "descricao_categoria" },
  { text: "ID Usuário", value: "id_usuario_criacao" },
  { text: "Nome Usuário", value: "nome_usuario" },
  { text: "Data Limite", value: "data_limite_br" },
  { text: "Ações", value: "acoes", sortable: false },
];

const CALLBACK_ATUALIZAR_GRID_CATEGORIAS_COMPUTED = computed(() => store.getters['compraMateriaPrima/callbackAtualizarGridCategorias']);
const CALLBACK_ATUALIZAR_CARDS_TOTAIS_COMPUTED = computed(() => store.getters['compraMateriaPrima/callbackAtualizarCardsTotais']);

const dialog_ativo = ref(false);
watch(dialog_ativo, () => {
  buscarQtdeCategoriasSilenciadas();
  CALLBACK_ATUALIZAR_GRID_CATEGORIAS_COMPUTED.value();
  CALLBACK_ATUALIZAR_CARDS_TOTAIS_COMPUTED.value();
});

const qtde_categorias_silenciados = ref(null);
const categorias_silenciadas = ref([]);
const categorias_selecionadas = ref([]);
const pesquisa = ref("");

const GRUPO_COMPRA_COMPUTED = computed(() => store.getters['usuario/getGrupoCompras']);

onMounted(() => {
  buscarQtdeCategoriasSilenciadas();
  store.dispatch("compraMateriaPrima/callbackAtualizarQtdeCategoriasSilenciadas", buscarQtdeCategoriasSilenciadas);
});

function buscarQtdeCategoriasSilenciadas() {
  const parametros = {
    grupo: GRUPO_COMPRA_COMPUTED.value
  };

  store.dispatch("loading/addRequisicao",
    req.buscarQtdeCategoriasSilenciadas(parametros)
      .then(qtde => qtde_categorias_silenciados.value = qtde)
      .catch(logout)
  );
}

function abrirDialog() {
  dialog_ativo.value = true;
  buscarCategoriasSilenciadas()
}

function buscarCategoriasSilenciadas() {
  const parametros = {
    grupo: GRUPO_COMPRA_COMPUTED.value
  };

  store.dispatch("loading/addRequisicao",
    req.buscarCategoriasSilenciadas(parametros)
      .then(categorias => categorias_silenciadas.value = categorias)
      .catch(logout)
  );
}

function excluirCategoriasSilenciadas(ids_silenciamentos) {
  const parametros = {
    ids_silenciamentos,
    id_usuario: localStorage.id
  };

  store.dispatch("loading/addRequisicao",
    req.excluirCategoriasSilenciadas(parametros)
      .then(() => {
        buscarCategoriasSilenciadas();
        categorias_selecionadas.value = [];
      })
      .catch(logout)
  );
}
</script>
